import type { MouseEvent, PropsWithChildren } from 'react'
import { forwardRef } from 'react'

import { type PaletteProps } from '@material-ui/system'

import { Icon, type IconTypes } from '../Icon'
import { TagStyled } from './styles/TagStyled'

export interface ITagProps extends PaletteProps {
  icon?: IconTypes
  onClick?(e: MouseEvent<HTMLElement>): void
  fullWidth?: boolean
}

export const Tag = forwardRef<HTMLDivElement, PropsWithChildren<ITagProps>>(
  ({ icon, onClick, children, ...props }, ref) => {
    return (
      <TagStyled onClick={onClick} {...props} ref={ref}>
        {children}
        {icon ? <Icon icon={icon} /> : null}
      </TagStyled>
    )
  }
)

Tag.displayName = 'Tag'
